import React from 'react'
import { withRouter } from 'react-router-dom'
import FormHelper from '../../../utils/FormHelper'
import ChangePasswordWorker from './change-password'
import '../../../assets/styles/form.scss'
import './change-password.styles.scss'

class ChangePassword extends React.Component {

    constructor(props) {
        super(props)
        this.changePasswordWorker = ChangePasswordWorker(this)
        this.state = this.changePasswordWorker.getDefaultState()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.changePasswordWorker.isValid() && this.changePasswordWorker.changePassword()
    }

    onCancel = () => {
        this.setState(this.changePasswordWorker.getDefaultState())
    }

    render() {
        return (
            <div className="change-password">
                <div className="card">
                    <div className="header">
                        <h4>Change Password</h4>
                    </div>
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <form onSubmit={this.onSubmit}>
                        <div className="form-input">
                            <label>Current Password</label>
                            <input type="password" name="currentPassword" value={this.state.currentPassword} onChange={FormHelper(this).onChange} />
                            <span className="error">{this.state.errors.currentPassword}</span>
                        </div>
                        <div className="form-input">
                            <label>New Password</label>
                            <input type="password" name="password" value={this.state.password} onChange={FormHelper(this).onChange} />
                            <span className="error">{this.state.errors.password}</span>
                        </div>
                        <div className="form-input">
                            <label>Confirm Password</label>
                            <input type="password" name="confirmPassword" value={this.state.confirmPassword} onChange={FormHelper(this).onChange} />
                            <span className="error">{this.state.errors.confirmPassword}</span>
                        </div>
                        <div className="actions">
                            <button type="reset" onClick={this.onCancel}>Reset</button>
                            {
                                this.state.saving?
                                <button type="submit" disabled>Save</button>:
                                <button type="submit">Save</button>
                            }
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

export default withRouter(ChangePassword)
